import { useCallback } from "react";

import { ProductKey } from "../../../../commons/specs/product";
import type { GetPrintItem } from "../../../../commons/types/print-mail";

/**
 * Returns a function that returns a print data item for a given product.
 * Currently does not respect the `advertiser` setting, because this is not available on mobile.
 *
 * @returns {GetPrintItem} A function that returns a print data item for a given product.
 */
export function useGetMobilePrintDataItem(): {
  getPrintItem: GetPrintItem;
} {
  const getPrintItem: GetPrintItem = useCallback(({ variantId, product }) => {
    return {
      productId: product[ProductKey.ProductId],
      variantId,
      product
    };
  }, []);

  return {
    getPrintItem
  };
}
